var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99998 4C8.95702 4.00132 7.95716 4.41622 7.21968 5.1537C6.4822 5.89118 6.0673 6.89104 6.06598 7.934H8.06598C8.06598 6.867 8.93398 6 9.99998 6C11.066 6 11.934 6.867 11.934 7.934C11.934 8.532 11.453 8.966 10.718 9.56C10.4779 9.7481 10.2472 9.94801 10.027 10.159C9.02898 11.156 8.99998 12.215 8.99998 12.333V13H11L10.999 12.367C11 12.351 11.032 11.981 11.44 11.574C11.59 11.424 11.779 11.274 11.975 11.116C12.754 10.485 13.933 9.532 13.933 7.934C13.9322 6.89106 13.5176 5.89104 12.7802 5.15347C12.0428 4.4159 11.0429 4.00106 9.99998 4ZM8.99998 14H11V16H8.99998V14Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.486 0 0 4.486 0 10C0 15.514 4.486 20 10 20C15.514 20 20 15.514 20 10C20 4.486 15.514 0 10 0ZM10 18C5.589 18 2 14.411 2 10C2 5.589 5.589 2 10 2C14.411 2 18 5.589 18 10C18 14.411 14.411 18 10 18Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestionMark);
export default __webpack_public_path__ + "static/media/icon-question-mark.c99888ee05ebb2df0ec94d545b25494a.svg";
export { ForwardRef as ReactComponent };